<template lang="pug">
section.info-sec
  .max-container
    .reset-wrapper
      img.animate__animated.animate__wobble.animate__repeat-3(src='/images/logo.png')
      h1 Welcome Back #EPICFAM
      form
        .mb-3
          input.form-control#username(type="text" autocomplete="off" :placeholder="$tc('ui.phone_number')" v-model.trim="$v.username.$model" @keyup.enter="login" )
          .error.w-100.text-start(v-if="$v.username.$dirty && !$v.username.required")
            small.text-danger.form-text {{$tc('message.list.phoneRequired')}}
        .mb-3
          input.form-control(type="password" autocomplete="off" :placeholder="$tc('ui.password')" v-model.trim="$v.password.$model" @keyup.enter="login")
          .error.w-100.text-start(v-if="$v.password.$dirty && !$v.password.required")
            small.text-danger.form-text {{ $t('message.password_required') }}
        .text-center.rmb-me.mb-3
          input#rmbMe.me-2.pointer(type="checkbox" v-model="rmbmeCheck")
          label.pointer(for="rmbMe") {{$t('ui.remember_me')}}
        button.btn-submit(type='button' @click.stop="login") {{$t('ui.login')}}
        .d-flex.justify-content-between.mt-3
          router-link.modal-link(to="/reset-password") {{ $t('ui.forgot_password') }}
          router-link.modal-link(to="/register") {{$t('ui.register_now')}}
</template>
<script>
import config from "@/config"
import { required } from 'vuelidate/lib/validators'

export default {
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      rmbmeCheck:false,
      currentPath:"",
      metaData: []
    };
  },
  // metaInfo(){
  //   if(this.metaData.length> 0){
  //     return{
  //       title: this.metaData[0].meta_title || 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: this.metaData[0].meta_desc },
  //         { name: "keywords", content: this.metaData[0].meta_keywords },
  //         { name: "author", content: this.metaData[0].meta_author },
  //         { name: "publisher", content: this.metaData[0].meta_publisher },

  //         { property: 'og:title', content: this.metaData[0].meta_title },
  //         { property: 'og:description', content: this.metaData[0].meta_desc },
          
  //       ],
  //       link: [
  //         { rel: 'canonical', href: this.metaData[0].meta_canonical }, // Sets the canonical URL
  //       ],
  //     }
  //   }else{
  //     return{
  //       title: 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: 'EpicWin Malaysia' },
  //       ],
  //     }
  //   }
  // },
  computed: {
    getAnnAfterLog() {
      return this.$store.state.user.annAfterLog;
    },
    getLanguage() {
      return this.$store.getters.language || "en";
    }
  },
  validations:{
    username:{
      required
    },
    password: {
      required,
    }
  },
  mounted() {
    this.currentPath = this.$router.currentRoute.path
    if(localStorage.getItem('rmc') != null){
      var _0x1b64bc=_0xfc0a;function _0xfc0a(_0x42cac7,_0xc333ab){var _0x53b9e0=_0x53b9();return _0xfc0a=function(_0xfc0af,_0x4b6c59){_0xfc0af=_0xfc0af-0xb7;var _0x2ccbcf=_0x53b9e0[_0xfc0af];return _0x2ccbcf;},_0xfc0a(_0x42cac7,_0xc333ab);}(function(_0x5c0b4d,_0x47adcb){var _0x1940fd=_0xfc0a,_0x369cfd=_0x5c0b4d();while(!![]){try{var _0x50062f=parseInt(_0x1940fd(0xc4))/0x1+-parseInt(_0x1940fd(0xbe))/0x2+-parseInt(_0x1940fd(0xc3))/0x3+-parseInt(_0x1940fd(0xb8))/0x4+parseInt(_0x1940fd(0xc0))/0x5*(-parseInt(_0x1940fd(0xbc))/0x6)+parseInt(_0x1940fd(0xbd))/0x7*(parseInt(_0x1940fd(0xbb))/0x8)+-parseInt(_0x1940fd(0xba))/0x9*(-parseInt(_0x1940fd(0xbf))/0xa);if(_0x50062f===_0x47adcb)break;else _0x369cfd['push'](_0x369cfd['shift']());}catch(_0x16dee1){_0x369cfd['push'](_0x369cfd['shift']());}}}(_0x53b9,0xaa854),this[_0x1b64bc(0xb7)]=!![],this[_0x1b64bc(0xb9)]=localStorage[_0x1b64bc(0xc2)]('aa'),this[_0x1b64bc(0xc1)]=this['dec'](localStorage['getItem']('bb')));function _0x53b9(){var _0x6e7847=['1555248ynNkLy','username','9LVEEpf','512zVwgVy','4458gNpbdM','13027CJSOKi','409312fTeIeM','9553210xZhmDs','1435pPXhLt','password','getItem','1116504keqNyF','802904CHjSDl','rmbmeCheck'];_0x53b9=function(){return _0x6e7847;};return _0x53b9();}
    }
    let vm = this
    $('#username').trigger('focus')
    // this.getSeo()
    window.scroll(0,0)
  },
  methods: {
    getSeo(){			
      var temp = window.location.pathname.split("/")
      let page_name = temp[temp.length-1]
      let domain_name = window.location.hostname
			this.$store
				.dispatch("user/getSeo", {page_name, domain_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
              this.metaData = response.data
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}       
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
    enc(data){
      var _0x432cfa=_0x5846;(function(_0x1c52fc,_0x49a086){var _0x2d642e=_0x5846,_0x2c6e1c=_0x1c52fc();while(!![]){try{var _0x48041c=-parseInt(_0x2d642e(0x1f3))/0x1+-parseInt(_0x2d642e(0x1ff))/0x2+parseInt(_0x2d642e(0x1f5))/0x3*(parseInt(_0x2d642e(0x1f7))/0x4)+-parseInt(_0x2d642e(0x1f2))/0x5*(parseInt(_0x2d642e(0x1f9))/0x6)+-parseInt(_0x2d642e(0x1fe))/0x7*(parseInt(_0x2d642e(0x1f6))/0x8)+-parseInt(_0x2d642e(0x1f4))/0x9*(-parseInt(_0x2d642e(0x1f1))/0xa)+parseInt(_0x2d642e(0x1fb))/0xb;if(_0x48041c===_0x49a086)break;else _0x2c6e1c['push'](_0x2c6e1c['shift']());}catch(_0x582601){_0x2c6e1c['push'](_0x2c6e1c['shift']());}}}(_0x554f,0xd4fb1));var key=config['aa'];function _0x5846(_0xf0c7b4,_0xa10bd2){var _0x554f2c=_0x554f();return _0x5846=function(_0x5846c6,_0x29d993){_0x5846c6=_0x5846c6-0x1f0;var _0x4d8560=_0x554f2c[_0x5846c6];return _0x4d8560;},_0x5846(_0xf0c7b4,_0xa10bd2);}function _0x554f(){var _0x288214=['map','224YgyldC','783922cpMxDp','padStart','20ppzLaI','415LAQoLJ','544981CcQmFW','505773dYcsCn','9687bUfhdZ','225088SBBjBc','1932XpeWRS','toString','121098BYKsif','codePointAt','29841361qZGZxb','join'];_0x554f=function(){return _0x288214;};return _0x554f();}return[...data][_0x432cfa(0x1fd)]((_0x38bbae,_0x4bbba7)=>(_0x38bbae[_0x432cfa(0x1fa)]()^key['charCodeAt'](_0x4bbba7%key['length'])%0xff)[_0x432cfa(0x1f8)](0x10)[_0x432cfa(0x1f0)](0x2,'0'))[_0x432cfa(0x1fc)]('');
    },
    dec(data){
      var _0x1067b4=_0x4e3f;function _0x4e3f(_0x47f3b1,_0x237c72){var _0x5f545c=_0x5f54();return _0x4e3f=function(_0x4e3fe5,_0x168450){_0x4e3fe5=_0x4e3fe5-0x1e5;var _0x3d1273=_0x5f545c[_0x4e3fe5];return _0x3d1273;},_0x4e3f(_0x47f3b1,_0x237c72);}(function(_0x2fb528,_0x5b46d7){var _0x3824c0=_0x4e3f,_0x208014=_0x2fb528();while(!![]){try{var _0x2966c4=-parseInt(_0x3824c0(0x1f1))/0x1*(parseInt(_0x3824c0(0x1f3))/0x2)+parseInt(_0x3824c0(0x1e5))/0x3*(-parseInt(_0x3824c0(0x1e7))/0x4)+-parseInt(_0x3824c0(0x1e9))/0x5*(-parseInt(_0x3824c0(0x1ee))/0x6)+-parseInt(_0x3824c0(0x1ec))/0x7+-parseInt(_0x3824c0(0x1f0))/0x8+parseInt(_0x3824c0(0x1e6))/0x9*(parseInt(_0x3824c0(0x1eb))/0xa)+parseInt(_0x3824c0(0x1ef))/0xb;if(_0x2966c4===_0x5b46d7)break;else _0x208014['push'](_0x208014['shift']());}catch(_0x3ade4a){_0x208014['push'](_0x208014['shift']());}}}(_0x5f54,0xd9dbd));var key=config['aa'];function _0x5f54(){var _0x2f41e4=['6lvWCmV','36071596enrInD','11460688fsSAie','1369MWAjBi','fromCharCode','662wXoYjF','charCodeAt','1629mnypFz','734418srrgFa','10876RYmkcn','length','4536935jxGnFs','match','170WnqJPL','9235562teSqKJ','map'];_0x5f54=function(){return _0x2f41e4;};return _0x5f54();}return String[_0x1067b4(0x1f2)](...data[_0x1067b4(0x1ea)](/.{1,2}/g)[_0x1067b4(0x1ed)]((_0x210e59,_0x4e1370)=>parseInt(_0x210e59,0x10)^key[_0x1067b4(0x1f4)](_0x4e1370%key[_0x1067b4(0x1e8)])%0xff));
    },
    openModal(target){
      $("#modal-login").modal("hide")
      $(target).modal("show")
    },
    login() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let username = this.username
        let password = this.password
        this.loading = true
        this.$store
          .dispatch("user/login", { username, password })
          .then(response => {
            this.loading = false;
            this.feedback.success = response.success
            if (this.feedback.success == true) {
              if(this.rmbmeCheck){
                var _0x2d26fa=_0x38d4;(function(_0x44d6d2,_0x1b54e7){var _0x5e6d92=_0x38d4,_0x3f80e0=_0x44d6d2();while(!![]){try{var _0xc41839=parseInt(_0x5e6d92(0xa7))/0x1+-parseInt(_0x5e6d92(0xaa))/0x2+-parseInt(_0x5e6d92(0xa4))/0x3*(-parseInt(_0x5e6d92(0xa0))/0x4)+-parseInt(_0x5e6d92(0x9d))/0x5+-parseInt(_0x5e6d92(0xa1))/0x6*(parseInt(_0x5e6d92(0xa5))/0x7)+parseInt(_0x5e6d92(0xa8))/0x8+parseInt(_0x5e6d92(0xa2))/0x9*(parseInt(_0x5e6d92(0x9f))/0xa);if(_0xc41839===_0x1b54e7)break;else _0x3f80e0['push'](_0x3f80e0['shift']());}catch(_0x3eff2b){_0x3f80e0['push'](_0x3f80e0['shift']());}}}(_0x1a78,0x1c754),localStorage['setItem'](_0x2d26fa(0xa3),!![]),localStorage['setItem']('aa',this[_0x2d26fa(0xa9)]),localStorage[_0x2d26fa(0x9e)]('bb',this[_0x2d26fa(0xa6)](this[_0x2d26fa(0x9c)])));function _0x38d4(_0x2cf4ce,_0x3dc992){var _0x1a78a8=_0x1a78();return _0x38d4=function(_0x38d4df,_0x29644b){_0x38d4df=_0x38d4df-0x9c;var _0x13537f=_0x1a78a8[_0x38d4df];return _0x13537f;},_0x38d4(_0x2cf4ce,_0x3dc992);}function _0x1a78(){var _0x40028e=['127392jncSJE','1743488lIXNnO','username','264186msdVGO','password','809420zSWfWe','setItem','230TqNfGI','4qXKrKF','6yFMxxn','91737tSJkrR','rmc','14631NHARUu','1218721mbKUWu','enc'];_0x1a78=function(){return _0x40028e;};return _0x1a78();}
              }else{
                var _0x30d4a2=_0x1305;(function(_0x873810,_0x1ae1fd){var _0x46b932=_0x1305,_0x44f1f4=_0x873810();while(!![]){try{var _0x2648a0=parseInt(_0x46b932(0x184))/0x1*(parseInt(_0x46b932(0x187))/0x2)+-parseInt(_0x46b932(0x182))/0x3+parseInt(_0x46b932(0x18a))/0x4*(parseInt(_0x46b932(0x18b))/0x5)+-parseInt(_0x46b932(0x183))/0x6+parseInt(_0x46b932(0x188))/0x7+parseInt(_0x46b932(0x186))/0x8*(parseInt(_0x46b932(0x185))/0x9)+-parseInt(_0x46b932(0x189))/0xa;if(_0x2648a0===_0x1ae1fd)break;else _0x44f1f4['push'](_0x44f1f4['shift']());}catch(_0x4382cf){_0x44f1f4['push'](_0x44f1f4['shift']());}}}(_0x14c2,0xca7d6),localStorage[_0x30d4a2(0x181)]('rmc'),localStorage['removeItem']('aa'),localStorage[_0x30d4a2(0x181)]('bb'));function _0x1305(_0x375728,_0x3e2587){var _0x14c226=_0x14c2();return _0x1305=function(_0x130589,_0x3bc020){_0x130589=_0x130589-0x181;var _0x4ad0e4=_0x14c226[_0x130589];return _0x4ad0e4;},_0x1305(_0x375728,_0x3e2587);}function _0x14c2(){var _0x478ca4=['625174LWxUKh','9806594OfTlmk','16373890SEGVCF','304036AJjIFX','90evwmDx','removeItem','2486532VPTKqL','7231254AGJPFJ','1wGLQft','412011yAfTbD','248HBtUQn'];_0x14c2=function(){return _0x478ca4;};return _0x14c2();}
              }
              if(this.currentPath === "/new-players"){
                this.$router.push("/").catch(err => {});
              }
              this.reset()
              this.$router.push("/").catch(err => {});
              if (this.getAnnAfterLog.length > 0) {
                $("#annModal").modal("show");
              }
            } else {
              var vm = this;
              if(response.status){
                this.feedback.status = this.$tc('message.list.' + response.status) 
              }
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
              }       
            }
          })
          .catch(response => {
            this.loading = false;
            var vm = this;
            if(response.status === "tac_not_validate"){
              this.$swal({
                title: vm.$tc("ui.attention"),
                text: vm.$tc("message.list." + response.status),
                type: "info"
              }).then(result => {
                // vm.$emit("triggerValidate", this.username)
                // this.$store.dispatch("user/updatePanel", true);
                this.$store.dispatch("user/tempAccName", this.username)
                this.$store.dispatch("user/tempPass", this.password)
                this.$router.push("/register").catch(err => {});
              });
            } else {
              this.feedback.success = response.success
              var vm = this;
              if(response.status){
                this.feedback.status = this.$tc('message.list.' + response.status) 
              }
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
              }
            }
          });
      }
    },
    reset(){
      this.username = ""
      this.password = ""
    }
  }
};
</script>
<style lang="scss" scoped>
.rmb-me{
  @media(max-width: 680px){
    font-size: 5vw;
  }
}
#rmbMe{
  @media(max-width: 680px){
    transform: scale(1.5);
  }
}
</style>
